export const AP_RSF_USER_LOADER = {
  desktop: `
<div class="cui cui-grid cui-container">
  <div
    class="cui-skeleton-heading -size--large -spacing--top-64 -spacing--bottom-20 -resolution--desktop"
  >
    <div class="cui-skeleton-heading__content" style="width: max(300px, 100%)">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div
    class="cui-skeleton-heading -size--medium -spacing--top-40 -spacing--bottom-40 -resolution--desktop"
  >
    <div class="cui-skeleton-heading__content" style="width: max(300px, 100%)">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
    </div>
  </div>
</div>`
};

export const AP_RSF_DOWNLOAD_LOADER = {
  desktop: `
<div class="cui cui-grid cui-container">
  <div class="cui-skeleton-rectangle -is--block" style="margin-top: 324px;">
    <div class="cui-skeleton__item" style="width: 230px; height: 64px;"></div>
  </div>
  <div class="cui-skeleton-rectangle -is--block -spacing--top-64">
    <div class="cui-skeleton__item" style="width: 300px; height: 40px;"></div>
  </div>
  <div class="cui-skeleton-paragraph -spacing--top-16">
    <div class="cui-skeleton-paragraph__content" style="width: 635px">
      <div class="cui-skeleton__item cui-skeleton__description"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
</div>`
};
